<template>
  <div class="ranking-page">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">排行榜</h1>
        <p class="subtitle">发现最热门的内容</p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="container">
      <!-- 排行榜分类 -->
      <el-tabs v-model="activeTab" class="ranking-tabs">
        <el-tab-pane v-for="category in categories"
                     :key="category.key"
                     :label="category.label"
                     :name="category.key">
          <!-- 时间筛选 -->
          <div class="time-filter">
            <el-radio-group v-model="timeRange" size="large">
              <el-radio-button label="day">日榜</el-radio-button>
              <el-radio-button label="week">周榜</el-radio-button>
              <el-radio-button label="month">月榜</el-radio-button>
            </el-radio-group>
          </div>

          <!-- 排行榜列表 -->
          <div class="ranking-list">
            <el-card v-for="(item, index) in getRankingList(category.key)"
                     :key="item.id"
                     class="ranking-item"
                     :class="{ 'top-three': index < 3 }">
              <!-- 排名 -->
              <div class="rank-number" :class="`rank-${index + 1}`">
                {{ index + 1 }}
              </div>

              <!-- 内容 -->
              <div class="item-content">
                <div class="item-main">
                  <el-image v-if="item.cover"
                           :src="item.cover"
                           class="item-image"
                           fit="cover" />
                  <div class="item-info">
                    <h3 class="item-title">{{ item.title }}</h3>
                    <p class="item-desc">{{ item.description }}</p>
                    <div class="item-meta">
                      <span class="author">
                        <el-avatar :size="20" :src="item.authorAvatar" />
                        {{ item.author }}
                      </span>
                      <div class="stats">
                        <span><el-icon><View /></el-icon> {{ item.views }}</span>
                        <span><el-icon><Star /></el-icon> {{ item.likes }}</span>
                        <span><el-icon><ChatDotRound /></el-icon> {{ item.comments }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 趋势 -->
                <div class="trend" :class="item.trend">
                  <el-icon v-if="item.trend === 'up'"><CaretTop /></el-icon>
                  <el-icon v-else-if="item.trend === 'down'"><CaretBottom /></el-icon>
                  <span>{{ item.trendValue }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { View, Star, ChatDotRound, CaretTop, CaretBottom } from '@element-plus/icons-vue'

export default {
  name: 'Ranking',
  components: {
    View,
    Star,
    ChatDotRound,
    CaretTop,
    CaretBottom
  },
  setup() {
    const activeTab = ref('entertainment')
    const timeRange = ref('day')

    // 更新排行榜分类
    const categories = ref([
      { key: 'entertainment', label: '娱乐榜' },
      { key: 'movie', label: '影视榜' },
      { key: 'global', label: '全球榜' },
      { key: 'music', label: '音乐榜' },
      { key: 'sports', label: '体育榜' },
      { key: 'game', label: '游戏榜' },
      { key: 'finance', label: '财经榜' },
      { key: 'food', label: '美食榜' }
    ])

    // 模拟排行榜数据
    const rankingData = {
      entertainment: [
        {
          id: 1,
          title: '某某明星官宣恋情',
          description: '娱乐圈再添一对金童玉女...',
          cover: 'https://via.placeholder.com/120x160',
          author: '娱乐周刊',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '150w',
          likes: 52420,
          comments: 12358,
          trend: 'up',
          trendValue: '+3'
        },
        // ... 更多娱乐数据
      ],
      movie: [
        {
          id: 1,
          title: '《流浪地球3》',
          description: '2024年最受期待科幻大片...',
          cover: 'https://via.placeholder.com/120x160',
          author: '电影日报',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '98w',
          likes: 45890,
          comments: 8432,
          trend: 'up',
          trendValue: '+1'
        },
        // ... 更多影视数据
      ],
      global: [
        {
          id: 1,
          title: '全球科技创新指数排名',
          description: '最新全球科技创新力排名发布...',
          cover: 'https://via.placeholder.com/120x160',
          author: '国际观察',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '86w',
          likes: 32890,
          comments: 6432,
          trend: 'up',
          trendValue: '+2'
        },
        // ... 更多全球数据
      ],
      music: [
        {
          id: 1,
          title: '新歌榜TOP1',
          description: '最新流行音乐排行...',
          cover: 'https://via.placeholder.com/120x160',
          author: '音乐风向标',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '120w',
          likes: 48890,
          comments: 9432,
          trend: 'up',
          trendValue: '+1'
        },
        // ... 更多音乐数据
      ],
      sports: [
        {
          id: 1,
          title: 'NBA季后赛积分榜',
          description: '最新NBA球队排名情况...',
          cover: 'https://via.placeholder.com/120x160',
          author: '体育周刊',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '95w',
          likes: 38890,
          comments: 7432,
          trend: 'down',
          trendValue: '-2'
        },
        // ... 更多体育数据
      ],
      game: [
        {
          id: 1,
          title: '热门游戏下载榜',
          description: '本周最受欢迎的游戏排名...',
          cover: 'https://via.placeholder.com/120x160',
          author: '游戏之声',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '78w',
          likes: 28890,
          comments: 5432,
          trend: 'up',
          trendValue: '+4'
        },
        // ... 更多游戏数据
      ],
      finance: [
        {
          id: 1,
          title: '全球市值TOP10企业',
          description: '最新全球企业市值排名...',
          cover: 'https://via.placeholder.com/120x160',
          author: '财经日报',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '65w',
          likes: 18890,
          comments: 3432,
          trend: 'up',
          trendValue: '+2'
        },
        // ... 更多财经数据
      ],
      food: [
        {
          id: 1,
          title: '2024年度美食排行榜',
          description: '最受欢迎的美食排名...',
          cover: 'https://via.placeholder.com/120x160',
          author: '美食家',
          authorAvatar: 'https://via.placeholder.com/40',
          views: '88w',
          likes: 35890,
          comments: 6932,
          trend: 'up',
          trendValue: '+3'
        },
        // ... 更多美食数据
      ]
    }

    // 获取对应分类的排行榜数据
    const getRankingList = (category) => {
      return rankingData[category] || []
    }

    return {
      activeTab,
      timeRange,
      categories,
      getRankingList
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 48px;
  margin: 10px 0; /* 调整上下间距 */
  padding-top: 30px;
  font-weight: 600; /* 加粗标题 */
}
.subtitle {
  font-size: 24px;
  opacity: 0.9; /* 稍微降低透明度 */
}
.banner {
  height: 300px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -60px;
}

.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.time-filter {
  margin: 20px 0;
  text-align: center;
}

.ranking-list {
  margin-top: 20px;
}

.ranking-item {
  margin-bottom: 15px;
  transition: transform 0.3s;
}

.ranking-item:hover {
  transform: translateX(5px);
}

.top-three {
  background: linear-gradient(to right, rgba(255,215,0,0.1), transparent);
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-main {
  display: flex;
  gap: 20px;
  flex: 1;
}

.rank-number {
  font-size: 24px;
  font-weight: bold;
  color: #999;
  width: 40px;
  text-align: center;
}

.rank-1 { color: #f5c518; }
.rank-2 { color: #c0c0c0; }
.rank-3 { color: #cd7f32; }

.item-image {
  width: 120px;
  height: 80px;
  border-radius: 4px;
}

.item-info {
  flex: 1;
}

.item-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
}

.item-desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.author {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
}

.stats {
  display: flex;
  gap: 15px;
  color: #999;
}

.stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.trend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}

.trend.up {
  color: #f56c6c;
  background: rgba(245,108,108,0.1);
}

.trend.down {
  color: #67c23a;
  background: rgba(103,194,58,0.1);
}

@media (max-width: 768px) {
  .banner {
    height: 200px;
  }

  .item-main {
    flex-direction: column;
    gap: 10px;
  }

  .item-image {
    width: 100%;
    height: 160px;
  }

  .item-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
